import {onDOMLoaded} from "../util/misc.js";

export default {};

function changeAboutUsCarousel(direction) {
  var loopOne = true;
  var tabInputs = $(".tab-input");

  tabInputs.each(function(key, value) {
    if (direction == 'previous') {
      if (value.checked && key == 0) {
        value.checked = false;
        tabInputs[tabInputs.length - 1].checked = true;
        loopOne = false;
      }
      else if (value.checked && loopOne) {
        value.checked = false;
        value.previousElementSibling.checked = true;
        loopOne = false;
      }
    }
    else if (direction == 'next') {
      if (key == (tabInputs.length - 1) && loopOne) {
        value.checked = false;
        tabInputs[0].checked = true;
      }
      else if (value.checked && loopOne) {
        value.checked = false;
        value.nextElementSibling.checked = true;
        loopOne = false;
      }
    }
  });
}

onDOMLoaded(() => {
  $(".owl-carousel").owlCarousel({
    margin: -16,
    loop: true,
    nav: true,
    navText: [
      "<i class='fa fa-angle-left'></i>",
      "<i class='fa fa-angle-right'></i>"
    ],
    dots: false,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    autoplaySpeed: 800,
    responsive:{
      0:{
        items:1,
      },
      768:{
        items:2,
      },
      1280:{
        items:3,
      },
    },
  });

  var owl = $('.about-us-carousel .owl-carousel');

  owl.on('dragged.owl.carousel', function(event) {
    var attr = $(".owl-item.active label").attr("for");
    $("#"+attr).prop("checked", true);
  });

  $(".about-us-carousel .owl-prev").click(function() {
    changeAboutUsCarousel("previous");
  });

  $(".about-us-carousel .owl-next").click(function() {
    changeAboutUsCarousel("next");
  });
});
